
























import { Component, Prop, Vue, Watch, Inject } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";

import FormErrors from "@/lib/components/FormErrors.vue";
import LoadingSpinner from "@/lib/components/LoadingSpinner.vue";

import ErrorConverterService from "@/modules/forms/error-converter.service";
import dataStore from "@/store";
import Plushie from "@/modules/plushie/plushie.model";
import PlushieStore from "@/modules/plushie/store";

import AcceptationForm from "./AcceptationForm.vue";
import UndoForm from "./AcceptSuccessPage/UndoForm.vue";

import CustomerPreviewStore from "../store";

@Component({
  metaInfo() {
    const component = this as AcceptPage;
    let titlePrefix = "";
    if (component.plushie != null) {
      titlePrefix = component.plushie.storeItemId + " - ";
    }

    return {
      title: titlePrefix + "Design Clarification",
    };
  },
  components: {
    AcceptationForm,
    UndoForm,
    LoadingSpinner,
    FormErrors,
  },
})
export default class AcceptPage extends Vue {
  @Prop({ required: true })
  public readonly plushieId!: string;

  @Inject("ErrorConverterService")
  private fErrorConverterService!: ErrorConverterService;

  private fCustomerPreviewDataStore: CustomerPreviewStore;
  private fPlushieDataStore: PlushieStore;

  private fErrorsList: string[] = [];

  private fIsLoading = true;

  get errorsList(): string[] {
    return this.fErrorsList;
  }

  get isLoading(): boolean {
    return this.fIsLoading;
  }

  get plushie(): Plushie | undefined {
    return this.fPlushieDataStore.getPlushieById(this.plushieId);
  }

  constructor() {
    super();
    this.fCustomerPreviewDataStore = getModule(CustomerPreviewStore, dataStore);
    this.fPlushieDataStore = getModule(PlushieStore, dataStore);
  }

  private async getPlushieData(plushieId: string): Promise<void> {
    await this.fPlushieDataStore.loadPlushieById({ id: plushieId });
  }

  @Watch("plushieId", { immediate: true })
  private async onPlushieIdChange(): Promise<void> {
    if (!this.plushieId) {
      return;
    }

    this.fIsLoading = true;

    try {
      await Promise.all([
        this.getPlushieData(this.plushieId),
        this.fCustomerPreviewDataStore.createCustomerPreviewApprovement(
          this.plushieId
        ),
      ]);

      await this.$router.push({
        name: "AcceptSuccessPage",
        query: { plushieId: this.plushieId },
      });
    } catch (e) {
      const errors = this.fErrorConverterService.describeError(e);
      this.fErrorsList.push(...errors);
    } finally {
      this.fIsLoading = false;
    }
  }
}
